import { RadioType } from '@axo/shared/ui/input/lib/Radio/RadioUI';
import RadioGroupUI, {
  IOption,
} from '@axo/shared/ui/input/lib/RadioGroup/RadioGroupUI';
import { Controller, FieldError } from 'react-hook-form';
import { usePrimaryState, useReloadValue, useValidationUI } from '../../hooks';
import { IField } from '../UI.types';

interface IRadioFieldUI<Fields> extends IField<Fields> {
  label?: string;
  radioStyle: RadioType;
  buttonSize?: 'large' | 'regular';
  options: IOption[];
  setButtonsHalfWidth?: boolean;
  testid?: string;
  shouldTouch?: boolean;
  error?: FieldError;
}

export function RadioFieldUI<Fields>({
  label,
  name,
  warningValidation,
  tooltipValidation,
  successValidation,
  options,
  radioStyle,
  registerOptions,
  buttonSize,
  setButtonsHalfWidth = false,
  shouldTouch = false,
  error,
  'data-testid': testid,
}: IRadioFieldUI<Fields>) {
  useReloadValue(name, { shouldTouch });

  const { isValidating, infoBox } = useValidationUI({
    name,
    warningValidation,
    tooltipValidation,
    successValidation,
    formControllerError: error,
  });

  const state = usePrimaryState({
    isValidating,
    infoBoxType: infoBox?.type,
    name,
  });

  return (
    <Controller
      name={name}
      rules={registerOptions}
      render={({ field }) => (
        <RadioGroupUI
          {...field}
          radioStyle={radioStyle}
          options={options}
          label={label}
          infoBox={infoBox}
          buttonHeight={buttonSize}
          setButtonsHalfWidth={setButtonsHalfWidth}
          state={state}
          testid={testid}
        />
      )}
    />
  );
}
